import React from 'react';
import Drawer, { DrawerProps } from '@mui/material/Drawer';
import { useClintMediaQuery } from '@/utils/hooks';

interface MobileDrawerProps extends Omit<DrawerProps, 'open'> {
  anchor: 'top' | 'bottom' | 'left' | 'right';
  open: boolean;
  handleClose: () => void;
  children: React.ReactNode;
}

const MobileDrawer = (props: MobileDrawerProps) => {
  const { open, children, handleClose, anchor, ...otherProps } = props;
  const isMobile = useClintMediaQuery();

  const toggleDrawer = (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    handleClose();
  };

  if (!isMobile) {
    return null;
  }

  return (
    <Drawer anchor={anchor} open={open} onClose={toggleDrawer} {...otherProps}>
      {children}
    </Drawer>
  );
};

export default MobileDrawer;
